import { render } from "./user-account-change-password.vue?vue&type=template&id=e60781ae"
import script from "./user-account-change-password.vue?vue&type=script&lang=js"
export * from "./user-account-change-password.vue?vue&type=script&lang=js"
script.render = render

export default script